// extracted by mini-css-extract-plugin
module.exports = {"header":"Layout-Header_header_1vaxw","wrapper":"Layout-Header_wrapper_7feQ8 structure_pageContainer_3AHT8","logo":"Layout-Header_logo_2iFvE"};